const SessionTokenKeys = {
  ID_TOKEN: 'id_token',
  REFRESH_TOKEN: 'refresh_token'
};

const AppLanguageKeys = {
  APP_LANGUAGE: 'language'
};

export { SessionTokenKeys, AppLanguageKeys };
